export enum PayTo {
  payToGroup = 'Pay to Group',
  payToAgent = 'Pay to Agent',
  payToAgentSubAgent = 'Pay to Agent/Sub Agents',
}
